function getSensorKindName(sensorKind: number, childKind: number) {
    if (sensorKind === 1) {
        return '水位';
    } else if (sensorKind === 2) {
        if (childKind === 1) {
            return '風向';
        } else if (childKind === 2) {
            return '風速';
        } else if (childKind === 3) {
            return '温度';
        } else if (childKind === 4) {
            return '湿度';
        } else if (childKind === 5) {
            return '雨量';
        } else if (childKind === 6) {
            return 'WBGT(暑さ指数)';
        }
    } else if (sensorKind === 3) {
        if (childKind === 1) {
            return '騒音';
        } else if (childKind === 2) {
            return '振動';
        }
    }
}

export default getSensorKindName;
